import { create } from 'zustand';
import api from '../lib/axios';

const useAuthStore = create((set) => ({
  user: null,
  loading: true,

  fetchUser: async () => {
    try {
      const { data } = await api.get('/user');
      set({ user: data, loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },

  login: async (email, password) => {
    const { data } = await api.post('/login', { email, password });
    set({ user: data.user });
    return data;
  },

  logout: async () => {
    await api.post('/logout');
    set({ user: null });
  },

  clearUser: () => set({ user: null, loading: false }),
}));

export default useAuthStore;
